import React, { ReactElement, useContext } from 'react'
import styled from "styled-components";
import { AppSettingsContext } from '../../App/AppSettingsContextContainer';

interface IMapContainerProps {
    isMobile: boolean
}

interface IProps {
    children: ReactElement[]
}

const MapContainer = styled.div<IMapContainerProps>`
    height: 100%;

    display: flex;

    flex-direction: ${props => props.isMobile ? "column" : "row"};
`;

export default function MapAndSidePanelContainer(props: IProps) {
    const appSettingsContext = useContext(AppSettingsContext);

    return (
        <MapContainer isMobile={appSettingsContext.isMobile}>{props.children}</MapContainer>
    )
}